import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";
import { ResourceRule } from "@app/models/rest/resource-rule";
import { ResourceRuleRestService } from "@app/services/hal/resource-rule-rest.service";

@Injectable({ providedIn: "root" })
export class ResourceRuleStore extends RealTimeDataStore<ResourceRule> {
  constructor() {
    const resourceRuleRestService = inject(ResourceRuleRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(resourceRuleRestService, webStompSubscriber, hateoasResourceService);
    super.subscribeToMessaging("ResourceRule");
  }

  public findByResource(resource: any) {
    return this.loadWithSearch("findByResource", {
      pageParams: {
        size: 5000
      },
      params: {
        resource: resource.getSelfLinkHref()
      }
    });
  }
}
